import { GripVertical, X, RefreshCw } from 'lucide-react'
import { cn } from '@/lib/utils.ts'

interface WidgetWrapperProps {
  title: string
  icon?: React.ReactNode
  children: React.ReactNode
  onRemove?: () => void
  onRefresh?: () => void
  isEditing?: boolean
  className?: string
}

export function WidgetWrapper({
  title,
  icon,
  children,
  onRemove,
  onRefresh,
  isEditing,
  className,
}: WidgetWrapperProps) {
  return (
    <div className={cn('bg-white rounded-lg border border-gray-200 flex flex-col h-full overflow-hidden', className)}>
      {/* Header */}
      <div className="flex items-center justify-between px-4 py-2.5 border-b border-gray-100 flex-shrink-0">
        <div className="flex items-center gap-2 min-w-0">
          {isEditing && (
            <GripVertical className="w-4 h-4 text-gray-300 cursor-grab flex-shrink-0 drag-handle" />
          )}
          {icon && <span className="text-brand-500 flex-shrink-0">{icon}</span>}
          <h3 className="text-xs font-bold uppercase tracking-wider text-gray-600 truncate">
            {title}
          </h3>
        </div>
        <div className="flex items-center gap-1">
          {onRefresh && (
            <button
              onClick={onRefresh}
              className="p-1 rounded hover:bg-gray-100 text-gray-400 hover:text-gray-600 transition-colors"
            >
              <RefreshCw className="w-3.5 h-3.5" />
            </button>
          )}
          {isEditing && onRemove && (
            <button
              onClick={onRemove}
              className="p-1 rounded hover:bg-red-50 text-gray-400 hover:text-red-500 transition-colors"
            >
              <X className="w-3.5 h-3.5" />
            </button>
          )}
        </div>
      </div>

      {/* Content */}
      <div className="flex-1 overflow-y-auto">
        {children}
      </div>
    </div>
  )
}
